// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__Zzrzj","paramInput":"JobSimulator_paramInput__Ebe21","input":"JobSimulator_input__2Ggsl"};